/* eslint-disable */
import React, { useState, useEffect,} from "react";
import { withRouter } from 'react-router';
import { Input, Dropdown, Menu, Tooltip, Row, Table, Col, Slider, Button, List, Typography, Modal, Radio, Select, InputNumber, Form, } from "antd";
import type { RadioChangeEvent } from 'antd';
import { SearchOutlined, CheckOutlined, PlusOutlined, MinusOutlined, CloseOutlined, ArrowLeftOutlined, DownOutlined, FallOutlined, RiseOutlined } from "@ant-design/icons";
import "./index.scss";
import { compareString, compareMiddle, filterOptions } from '../../utils/common-function';
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import EndpointDetails from "../EndpointDetails"

interface EndpointLibraryType {
  endpoint_std_term: string
  endpoint_category: string
  primary_frequency: number
  secondary_frequency: number
  endpoint_id: number
  cost: number
  endpoint_type: string
  modality: number[]
  usage_data: number[]
  hist_usage_data: number[]
  measure_timepoints: number[]
  hist_measure_timepoints: number[]
  total_trial: number
  added: boolean
  endpoint_context: string
  user_duration: number[]
  selected_modality: string
  details: [],
  is_lib_endpoint?: boolean
}


const AddEndpoint = (props) => {

    const initialEndpoint = {
      "endpoint_std_term": "",
      "endpoint_category": "",
      "primary_frequency": null,
      "secondary_frequency": null,
      "endpoint_id": null,
      "cost": null,
      "endpoint_type": 'Primary',
      "modality": [],
			"usage_data" : [],
      "hist_usage_data" : [],
      "measure_timepoints":[],
      "hist_measure_timepoints":[],
      "total_trial" : null,
      "added": false,
      'endpoint_context': "", 
      'user_duration':[],   
      'selected_modality': '',
      "details": [],
    }

    const {
        similarHistoricalTrials,
        trial_id,
        scenarioId,
        scenarioType,
        readOnly,
        endpointOrg,
        endpointAdded,
    } = props.location.state;    
    
    const [visibleValue, setVisibleValue] = useState(false);
    const [visibleFilterValue, setVisibleFilterValue] = useState(false);
    const [searchTxt,setSearchTxt] = useState("");
    const [searchEndpoint, setSearchEndpoint] = useState([])

    const [endpointActivityAddedLabs, setEndpointActivityAddedLabs] = useState([]);


    const [filteredActivities, setFilteredActivities] = useState<EndpointLibraryType[]>([]);
    const [endpointActivityFilteredLabs, setEndpointActivityFilteredLabs] = useState(endpointOrg)
   

    const [categories, setCategories] = useState([ "Labs", "Study Procedures", "Questionnaires", "Procedures", 'Physical Examination']);
    const categoryList = [ "Labs", "Study Procedures", "Questionnaires", "Procedures", 'Physical Examination' ]

   const [filterByCategories, setFilterByCategories] = useState([ "Labs", "Study Procedures", "Questionnaires", "Procedures", 'Physical Examination'])

    const FREQUENCY_RANGE_MIN = 0
    const FREQUENCY_RANGE_MAX = 100

    // Sets default min and max frequency for Criteria Frequency slider
    const FREQUENCY_DEFAULT_MIN = 0
    const FREQUENCY_DEFAULT_MAX = 100

    const [minV, setMinV] = useState(FREQUENCY_DEFAULT_MIN)
    const [maxV, setMaxV] = useState(FREQUENCY_DEFAULT_MAX)

    const [filterByMax, setFilterByMax] = useState(FREQUENCY_DEFAULT_MAX)
    const [filterByMin, setFilterByMin] = useState(FREQUENCY_DEFAULT_MIN)

    useEffect(() => {
      setEndpointActivityAddedLabs( [...endpointAdded])
    }, [ endpointAdded])


  const [addActivityModal, setAddActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(initialEndpoint)


    useEffect(() => {
      setFilteredActivities( 
        [...endpointActivityFilteredLabs])
    }, [endpointActivityFilteredLabs])


    const getFrequency = (value) => {
        setMinV(value[0])
        setMaxV(value[1])
      }
    
      const formatter = (value) => {
        return value+'%'
      } 

    const optionEndpoints = endpointOrg?.map((item, index)=>{
        return item
    }).filter(
      (i) =>
       i.primary_frequency * 100 >= FREQUENCY_RANGE_MIN && i.primary_frequency * 100 <= FREQUENCY_RANGE_MAX
      )

    let timer = null;
    const onTextChange = (e) => {
        const val = e.target.value.toLowerCase();
        let searchResult = []
        !visibleValue&&setVisibleValue(true);
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
            setSearchTxt(val)
            searchResult = val.length > 0 ? filterOptions(optionEndpoints, 'endpoint_std_term',val) : []
            setSearchEndpoint(searchResult)
          }, 200);
    }

  const renderItem = (title: string, idx: any, Frequency: any) => {  
    return (
      <Tooltip
      title={"Frequency " + Math.round(Frequency * 10000) / 100 + "%"}
      >
        <div   className="itemLine"   >
          <span className="itemTitle" style={{ width: '80%',display: 'inline-block',overflowWrap:'break-word', textOverflow: 'ellipsis'}}>
            {(searchTxt.length < title.length) && compareString(title, title.toLowerCase().split(searchTxt)[0])} 
            <span className={`${
              searchTxt &&
              title.toLowerCase().indexOf(searchTxt.toLowerCase()) > -1
                ? "matched-item"
                : ""
              }`}> 
                {compareMiddle(title, searchTxt.length - title.length === 0?title:searchTxt)}
            </span>
            { (searchTxt.length !== 0)&&(searchTxt.length < title.length) && compareMiddle(title, title.toLowerCase().slice((title.toLowerCase().split(searchTxt)[0]+(searchTxt.length - title.length === 0?title:searchTxt)+'').length))}
          </span>
          <span style={{width: '20%',display: 'inline-block',color:"#CA4A04", marginLeft:"25px"}}>
            Add
          </span>
        </div>
        </Tooltip>
        )
  }
  
  const addActivity = (e, record, idx) => {  
    setAddActivityModal(true)
    setSelectedActivity({
      ...record, 
      idx: idx,
      "endpoint_context":'',
      "endpoint_type":'',
      'user_duration': []
    })
  }

 

  const [panelTotal, setPanelTotal] = useState([])
  const [panelLabsData, setLabsPanelData] = useState([])

  useEffect(() => {
    setPanelTotal([...panelLabsData])
  }, [panelLabsData])

  const handleDetailUpdate = (value) => {
    // receive the updated detail data of the endpoint
    // console.log("detail updated", value);

    handleToggleActivity(value, 'add')
    setAddActivityModal(false);
    setSelectedActivity(initialEndpoint);
  }

  const handleToggleActivity = ( evt, flag) => { 
      let index = endpointActivityFilteredLabs.findIndex((d) => evt['endpoint_std_term'] == d['endpoint_std_term'])
      let addedIndex = panelLabsData.findIndex((d) => evt['endpoint_std_term'] == d['endpoint_std_term'])  
      const newData = [...endpointActivityFilteredLabs]
      const newSelectedData = [...endpointActivityAddedLabs]
      const newPanelData = [...panelLabsData] 
      if(flag === 'remove'){
      // if(evt.added){  
      //   for (let key in evt) {
      //     if (key == "endpoint") {
      //        delete evt[key];
      //     }
      //  }  
        newData.splice(index, 1, { ...evt, ...{added: false, condition: [], totalVisit: 0}}); 
        let selectedIndex = endpointActivityAddedLabs.findIndex((d) => evt['endpoint_std_term'] == d['endpoint_std_term'])
        newSelectedData.splice(selectedIndex, 1)

        newPanelData.splice(addedIndex, 1, { ...evt, ...{added: false, condition: [], totalVisit: 0}}); 
        let panelSelectedIndex =  panelLabsData.findIndex((d) => evt['endpoint_std_term'] == d['endpoint_std_term'])
        newPanelData.splice(panelSelectedIndex, 1)
      } else {
        newData.splice(index, 1, { ...evt, ...{added: true, selected_modality: null,}});
        newSelectedData.push(Object.assign(evt, {added: true, selected_modality: null,}))

        newPanelData.push(Object.assign(evt, {added: true, selected_modality: null,}))
      }
      setLabsPanelData(newPanelData)
      setEndpointActivityAddedLabs(newSelectedData)
      setEndpointActivityFilteredLabs(newData) 
 
      setAddActivityModal(false);
      setSelectedActivity(initialEndpoint);

     // props.handleEventChange()
  }

  const checkIsTrending = (status) => {
    let content = (<></>);
    if(status && status?.toLowerCase() === 'up') {
      content = (<RiseOutlined style={{color: '#88C540', fontSize:'24px'}} />)
    } else if(status && status?.toLowerCase() === 'down') {
      content = (<FallOutlined style={{color: '#CC0537', fontSize:'24px'}} />)
    }
    return content;
  }
  

    const columns = [
        {
        title: "Endpoints",
        dataIndex: "endpoint_std_term",
        ellipsis: true, 
        width: '32%',
        sorter: (a, b) => (a['endpoint_std_term'] < b['endpoint_std_term'] ? -1 : 1), 
        },
        {
        title: "Category",
        dataIndex: "endpoint_category",
        sorter: (a, b) => (a.endpoint_category < b.endpoint_category ? -1 : 1),
        ellipsis: true
        },
        {
        title: "Primary endpoint frequency",
        dataIndex: "primary_frequency",
        sorter: (a, b) => (a.primary_frequency < b.primary_frequency ? -1 : 1),
        render: (_, item) =>  Math.round(item['primary_frequency'] * 10000) / 100 + "%"
        
        },
        {
        title: "Secondary endpoint frequency",
        dataIndex: "secondary_frequency",
        sorter: (a, b) => (a.secondary_frequency < b.secondary_frequency ? -1 : 1),
        render: (_, item) =>  Math.round(item['secondary_frequency'] * 10000) / 100 + "%"
        },
        {
          title: "Trending",
          dataIndex: "trend", 
          width: '90px',
          sorter: (a, b) => {  
            if (a.trend === b.trend) {  
              return 0;  
            } else if (a.trend === "UP") {  
              return -1;  
            } else if (b.trend === "UP") {  
              return 1;  
            } else if (a.trend === "DOWN") {  
              return -1;  
            } else {  
              return 1;  
            }  
          } ,
          ellipsis: true,
          render: (_, item) =>  checkIsTrending(item['trend'])
          },
        {
          title: '',
          dataIndex: 'operation',
          width: '90px',
          render: (_, record, index) => { 
            // return record.added ? (<div style={{float: 'right', marginRight: 30}}><span style={{paddingRight: '10px', fontSize: '16px'}}> <CheckOutlined /></span>ADDED</div>) :
            // (
            return <div className="endpoint-lib" style={{float: 'right', marginRight: 9}} >
            <Button  onClick={(e) => addActivity(e, record, index)} className="add-button">Add</Button>
            </div>
            // )
        }
      }
    ];

    const onItemClick = ({ key }) => {
      const item = JSON.parse(key);
      if(!item.added) {
        setAddActivityModal(true); 
        setVisibleValue(false);
        setSelectedActivity(item) 
      }
     
     // handleEventChange([])
    }

     
    const menu = (
        <Menu onClick={onItemClick}>
          {(searchTxt.length !== 0)&&searchEndpoint.length>0 && (<Menu.ItemGroup title="">
           {
              searchEndpoint.slice(0, 10).map((item,idx)=>{
                  return <Menu.Item key={JSON.stringify({...item, added: false})}>
                    {renderItem(item['endpoint_std_term'], idx, item.primary_frequency)}
                  </Menu.Item>
              })
            }
          </Menu.ItemGroup>)}
          {searchTxt.length === 0 && <div style={{cursor: "none", padding: 20}}></div>}
          {(searchTxt.length !== 0 && searchEndpoint.length
            === 0) &&
           <div key="no-result" style={{cursor: "none", padding: 20}}>There are no endpoints in the library that match your search.</div>}
        </Menu>
    );


    const onCategorySelect = ({ key }) => {
      let item = JSON.parse(key.slice(1));
      const newData = [...categories]
      let index = newData.findIndex((d) => d == item);
      if(index < 0) {
        newData.push(item)
      } else {
        newData.splice(index, 1)
      }
      setCategories(newData)
    }

    const cancelFilterDisplay = () => {
      setVisibleFilterValue(false)
      setFilterByCategories(categoryList)
      setCategories(categoryList)
    }

    const applyFilters = () => {
      setFilterByCategories(categories)
      setVisibleFilterValue(false) 
      setFilterByMin(minV)
      setFilterByMax(maxV)
    }

    const filterMenu=(
      <div className="category-filters">
        <div className="content">
          <span>Set Frequency</span>
          <span style={{ float: "right", fontWeight: 'bold' }}>
            {minV}% - {maxV}%
          </span>
        </div>
        <Slider
          min={FREQUENCY_RANGE_MIN}
          max={FREQUENCY_RANGE_MAX}
          range={{ draggableTrack: true }}
          defaultValue={[minV, maxV]}
          tipFormatter={formatter}
          onAfterChange={getFrequency}
        />
         <Menu onClick={onCategorySelect}>
          {categoryList.map((list_item) => (  <Menu.Item  key={"D"+JSON.stringify(list_item)}>  
          <>
          {categories.includes(list_item) ? (
             <span style={{width: '20%',display: 'inline-block',color:"#3193E5", fontWeight:700, marginLeft:"25px"}}>
             <CheckOutlined />
             </span>
          ) : (
            <span style={{width: '20%',display: 'inline-block',color:"#CA4A04", marginLeft:"25px"}}>
            X
          </span>
          )} 
      </>
      {list_item} </Menu.Item>))} 
         </Menu>
         <div>
          <Button className="cancel-filters" onClick={cancelFilterDisplay}>Cancel</Button>
          <Button className="apply-filters" onClick={applyFilters}>Apply</Button>
         </div>
      </div>
    )

    const addActivityToEndpoint = () => {

      // console.log("endpointActivityAddedLabs",endpointActivityAddedLabs);
      
      props.updateEndpoints({
        endpointAdded: endpointActivityAddedLabs,

      });
      
      // This is used for auto saving functionality
      localStorage.setItem('whetherSaveEndpoint', 'true')
      
      props.history.push({
        pathname: '/scenario',
        state: {
          trial_id: trial_id,
          scenarioId: scenarioId, 
          scenarioType: scenarioType,
          similarHistoricalTrials: similarHistoricalTrials,
        }  
      }) 
    }

    const navigateBack = () => {
      if(!readOnly){
        addActivityToEndpoint()
      }else{
        props.history.push({
          pathname: '/scenario',
          state: {
            trial_id: trial_id,
            scenarioId: scenarioId, 
            scenarioType: scenarioType,
            similarHistoricalTrials: similarHistoricalTrials,
          }  
        }) 
      }
    }

    const [tableListItems, setTableListItems] = useState<EndpointLibraryType[]>([])
    const [current, setCurrent] = useState(1) 

    useEffect(() => {
      setTableListItems(filteredActivities.filter((d)=>{
        return  (d.primary_frequency * 100 >= filterByMin && d.primary_frequency * 100 <= filterByMax && d.is_lib_endpoint) && filterByCategories.includes(d.endpoint_category) 
        || (d.secondary_frequency * 100 >= filterByMin && d.secondary_frequency * 100 <= filterByMax && d.is_lib_endpoint) && filterByCategories.includes(d.endpoint_category)
      })) 
    }, [filteredActivities, filterByCategories, filterByMax, filterByMin])

    const changePage = (page) => {
      setCurrent(page) 
    };
  
    return (
      <div className="endpoint-container">
        <div className="endpoint-header-layout"> 
          <div onClick={navigateBack} className="back-btn"><span style={{paddingRight: '10px'}}><ArrowLeftOutlined /></span>Back</div>
          <h3>Endpoints 
            {/* ({labCount + studyCount + procedureCount + questionnaireCount + examinationCount}) */}
            </h3>
          {/* <p className="sub-heading">You can add endpoints from the library</p> */}
        </div>

        <div className="endpoint-body-layout" > 
        <Row>
          <Col span={18} style={{padding: '2% 5% 5% 5%'}}>
            <Row> 
              <Col span={18}>
                <Dropdown
                  overlay={menu}
                  overlayClassName="searchbox"
                  className="search-endpoint"
                  visible={visibleValue} 
                  onVisibleChange={(visible: boolean) => {!visibleValue?setVisibleValue(true):setVisibleValue(false)}}
                >
                <Input
                    prefix={<SearchOutlined />}
                    style={{ width: '100%', height: 37 }}
                    allowClear
                    onChange={onTextChange}
                    onClick={e => e.preventDefault()} 
                    placeholder="Search by keyword" />
                   
                  </Dropdown>
              </Col>
              <Col span={6}>
              <Dropdown
                  overlay={filterMenu} 
                  className="search-endpoint-filters"
                  visible={visibleFilterValue} 
                  onVisibleChange={(visible: boolean) => {!visibleFilterValue?setVisibleFilterValue(true):setVisibleFilterValue(false)}}
                >
                <p>Category <DownOutlined  style={{paddingLeft: '3px'}}/></p>
                </Dropdown>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={24}>
              <Table
                  columns={columns}
                  dataSource= {tableListItems} 
                  pagination={{
                    position: ["bottomRight"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${tableListItems.length} items`,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions:["10", "20", "50", "100"],
                    onChange: changePage,
                    current: current,
                    total: tableListItems.length
                  }} 
                />
              </Col>
           
            </Row>
          </Col>
          <Col span={6} className="activities-container">
          <div className="side-panel-heading">Selected endpoints
          ({panelTotal?.length})
          </div>

          <List 
            className="lists-container"
            bordered
            dataSource={panelTotal.filter((d) => d.added)}
            renderItem={(item) => (
              <List.Item>
                <Typography.Text ><span className="category">{`${item['endpoint_std_term']}`}</span><span className="sub-category">{`in ${item['endpoint_category']}`}</span> </Typography.Text> 
                <span style={{float: 'right', cursor: 'pointer'}} onClick={(e) => handleToggleActivity( item, 'remove')}>
                  <CloseOutlined />
                </span> 
              </List.Item>
            )}
          />
          <div className="endpoint-btn-container">
            <Button 
            onClick={addActivityToEndpoint}
            disabled={readOnly}
            className="add-endpoint"
            >Add to endpoints</Button>
            <br />
          </div>
          </Col>
        </Row>
        </div>
        <EndpointDetails
          whetherModal = {addActivityModal}
          selectedData = {selectedActivity}
          handleDetailUpdate = {handleDetailUpdate}
          isBuilderTable={false}
        />   
      </div>    
    )
}

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  updateEndpoints: (val) => dispatch(createActions.updateEndpoints(val))
});
const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  newEndpoint: state.endpointReducer,
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddEndpoint));